/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react'
import Main from '../../../components/HOC/Main'
import IndustriesForm from '../../../components/pages/IndustriesForm'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/common/Button';
import { selectSelectedIndustries, setSelectedIndustries, toggleCommonDeleteModal, toggleIndustriesSlide } from '../../../store/slices/common';
import CustomTable from '../../../components/common/CustomTable';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { clearIndustriesData, deleteIndustries, fetchIndustries, selectIndustriesData, setIndustriesData } from '../../../store/slices/api/inner/industriesSlice';
import TableAction from '../../../components/TableAction';
import { FaPlus } from 'react-icons/fa';

export default function IndustriesPage() {
  const dispatch = useDispatch();
  const industriesData = useSelector(selectIndustriesData);
  const selectedIndustries = useSelector(selectSelectedIndustries)

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchIndustries,
    setValueAction: setIndustriesData,
    clearValueActionOnError: clearIndustriesData,
    isForm: false,
    successMessage: false,
  });

    // delete start
    const openDeleteModal = (data) => {
      dispatch(setSelectedIndustries(data))
      dispatch(toggleCommonDeleteModal())
    }
    const cancelDeleteModal = () => {
      dispatch(setSelectedIndustries(null))
      dispatch(toggleCommonDeleteModal())
    }
  
    const afterAPICall = (res) => {
      fetchData()
      dispatch(toggleCommonDeleteModal())
    }
  
    const { handleSubmit: handleDelete } = useApiRequest({
      apiAction: deleteIndustries,
      isForm: false,
      afterAPICall,
    });
    // delete end

  const handleEdit = (data) => {
    dispatch(setSelectedIndustries(data));
    dispatch(toggleIndustriesSlide());
  }

  const handleAdd = () => {
    dispatch(setSelectedIndustries(null));
    dispatch(toggleIndustriesSlide())
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'industry_name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"industry name"
    },
    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Main crumbs={[{ title: "masters" }, {title: "industry"}]} handleDelete={() => {handleDelete({ industryId: selectedIndustries.industry_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={industriesData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add Industry</Button>} />
      <IndustriesForm defaultData={selectedIndustries} fetchData={fetchData} />
    </Main>
  )
}
